import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Routes, Route, Navigate,BrowserRouter } from "react-router-dom";
import Dashboard from './components/dashboard';
import ProductCategory from './components/masters/ProductCategory';
import ProductSubCategory from './components/masters/ProductSubCategory';
import ProductDetail from './components/masters/ProductDetail';
import Specification from './components/masters/Specification';
import ProductSpecification from './components/masters/ProductSpecification';
import ProductImage from './components/masters/ProductImage';
import ProductDetailById from './components/masters/ProductDetailById';
import Login from './components/login';
import CheckToken from './auth/authToken';
import { useState } from 'react';
import Blog from './components/masters/Blog';
import CouponCode from './components/masters/CouponCode';
import ContactUs from './components/contactus';
import Faqs from './components/masters/faqs';
import Orderlist from './components/orderlist';
import CustomerList from './components/customers/CustomerList';
import CustomerDetail from './components/customers/CustomerDetail';
import CustomerReviews from './components/customers/CustomerReview';
import OrderReport from './components/Reports/OrderReport';
import ProductReport from './components/Reports/ProductReport';
import MyProfile from './components/myprofle';
import ProductOfferBanner from './components/masters/ProductOfferBanner';
import CancelOrderType from './components/masters/CancelOrder';
import Colors from './components/masters/Colors';
import SizeType from './components/masters/Size';
import StockDetail from './components/StockDetail';
import BannerType from './components/masters/BannerType';
import Banner from './components/masters/Banner';
import BulkProductUpload from './components/bulkproductedit';
import BulkProductImageUpload from './components/bulkimageedit';
import StockSummary from './components/StockSummary';
import CustomOrder from './components/customOrder';
import ReturnType from './components/masters/OrderReturnType';
import CancelProductOrder from './components/CancelProductOrder';
import WeightType from './components/masters/WeightType';
import ShapeType from './components/masters/ShapeType';
import StaticPages from './components/StaticPages';
import OrderDetail from './components/orderlist/orderDetail';
import SocialVideo from './components/SocialVideo';
import InstaFeed from './components/InstaFeed';
import CelebSection from './components/CelebSection';
import CustomEnquiry from './components/customEnquiry';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const activeItemUrl = sessionStorage.getItem('activeItemUrl');

  return (
    <BrowserRouter>
      {/* Token check and login state management */}
      <CheckToken setIsLoggedIn={setIsLoggedIn} />

      <Routes>
        {/* Route for Login page (accessible only when not logged in) */}
        <Route path="/" element={isLoggedIn ? <Navigate to={activeItemUrl || 'dashboard'} /> : <Login />} />

        {/* Conditional routes for logged-in users */}
        {isLoggedIn && (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/productcategory" element={<ProductCategory />} />
            <Route path="/productsubcategory" element={<ProductSubCategory />} />
            <Route path="/productdetail" element={<ProductDetail />} />
            <Route path="/specification" element={<Specification />} />
            <Route path="/productspecification" element={<ProductSpecification />} />
            <Route path="/productimage" element={<ProductImage />} />
            <Route path="/productdetail/:id" element={<ProductDetailById />} />
            <Route path="/couponcode" element={<CouponCode />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/orderlist" element={<Orderlist />} />
            <Route path="/cancelorder" element={<CancelProductOrder />} />
            <Route path="/customerlist" element={<CustomerList />} />
            <Route path="/customerdetail/:id" element={<CustomerDetail />} />
            <Route path="/customer-reviews" element={<CustomerReviews />} />
            <Route path="/orderreport" element={<OrderReport />} />
            <Route path="/productreport" element={<ProductReport />} />
            <Route path="/myprofile" element={<MyProfile />} />
            <Route path="/offer" element={<ProductOfferBanner />} />
            <Route path="/cancelordertype" element={<CancelOrderType />} />
            <Route path="/returntype" element={<ReturnType />} />
            <Route path="/colortype" element={<Colors />} />
            <Route path="/sizetype" element={<SizeType />} />
            <Route path="/stockentry" element={<StockDetail />} />
            <Route path="/bannertype" element={<BannerType />} />
            <Route path="/banner" element={<Banner />} />
            <Route path="/bulkupload" element={<BulkProductUpload />} />
            <Route path="/bulkproductimage" element={<BulkProductImageUpload />} />
            <Route path="/stocksummary" element={<StockSummary />} />
            <Route path="/customorder" element={<CustomOrder />} />
            <Route path="/weighttype" element={<WeightType />} />
            <Route path="/shapetype" element={<ShapeType />} />
            <Route path="/staticpage" element={<StaticPages />} />
            <Route path="/order-details/:id" element={<OrderDetail />} />
            <Route path="/socialvideo" element={<SocialVideo />} />
            <Route path="/instafeed" element={<InstaFeed />} />
            <Route path="/celebsection" element={<CelebSection />} />
            <Route path="/customenquiry" element={<CustomEnquiry />} />
          </>
        )}

        {/* Redirect to Login page if not logged in */}
        {!isLoggedIn && <Route path="*" element={<Navigate to="/" />} />}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
